// This file defines the main navigation configuration used by the common UI library.

import type { TaasMenuItem } from 'utimaco-common-ui-angular';
import { ANNOUNCEMENT_ROLES, CUSTOMER_USER_ROLES } from './core/roles';

// See https://netbasal.com/simplifying-file-imports-in-angular-with-new-loader-options-4e94a0eb18af.
import announcementIcon from '@material-icons/svg/svg/announcement/baseline.svg';
import groupIcon from '@material-icons/svg/svg/group/baseline.svg';
import homeIcon from '@material-icons/svg/svg/home/baseline.svg';
import supportIcon from '@material-icons/svg/svg/support_agent/baseline.svg';

export function getMenuItems(userRoles: string[]): TaasMenuItem[] {
  const menuItems: TaasMenuItem[] = [
    {
      id: 0,
      type: 'link',
      active: true,
      name: $localize`:Main menu|Home navigation link@@mainMenu.home:Home`,
      link: '/',
      iconSvg: homeIcon,
      children: []
    },
    {
      id: 1,
      type: 'link',
      active: true,
      name: $localize`:Main menu|Announcements navigation link@@mainMenu.announcements:Announcements`,
      link: '/announcements',
      iconSvg: announcementIcon,
      children: [],
      requiredRoles: ANNOUNCEMENT_ROLES
    },
    {
      id: 2,
      type: 'section',
      active: false,
      name: $localize`:Main menu|Customer Support section@@mainMenu.customerSupport:Customer Support`,
      link: '/customer-support',
      iconSvg: supportIcon,
      requiredRoles: CUSTOMER_USER_ROLES,
      children: [
        {
          id: 3,
          type: 'link',
          active: false,
          name: $localize`:Main menu|Customer Users navigation link@@mainMenu.customerUsers:Customer Users`,
          link: '/customer-support/customer-users',
          iconSvg: groupIcon,
          children: [],
          requiredRoles: CUSTOMER_USER_ROLES
        }
      ]
    }
  ];

  return menuItems
    .filter(menuItem => hasRequiredRole(menuItem, userRoles))
    .map(menuItem => ({
      ...menuItem,
      children: menuItem.children.filter(childItem => hasRequiredRole(childItem, userRoles))
    }));
}

function hasRequiredRole(menuItem: TaasMenuItem, userRoles: string[]): boolean {
  return !menuItem.requiredRoles || menuItem.requiredRoles.some(role => userRoles.includes(role));
}
